module.exports = __webpack_public_path__ + "img/graphic1.cf9bbea6.jpg";